module.exports = __webpack_public_path__ + "static/media/nekojima.ad444767.png";